import { TFunction } from 'i18next';
import { StatusTypes } from 'api/traps/types';

export const statusClass = (status: StatusTypes): string => {
  switch (status) {
    case StatusTypes.APPROVED_MICE:
    case StatusTypes.CONSUMPTION:
      return 'success';

    case StatusTypes.REJECTED:
      return 'danger';

    case StatusTypes.APPROVED_NOT_MICE:
    case StatusTypes.CAUGHT_EMPTY:
    case StatusTypes.ACTIVITY:
      return 'warning';

    default:
      return '';
  }
};

export const statusTitle = (status: StatusTypes, t: TFunction): string => {
  switch (status) {
    case StatusTypes.APPROVED_MICE:
      return t('MCTDetail.TrapHistoryCard.modal.approveMice');

    case StatusTypes.APPROVED_NOT_MICE:
      return t('MCTDetail.TrapHistoryCard.modal.approveNotMice');

    case StatusTypes.CAUGHT_EMPTY:
      return t('MCTDetail.TrapHistoryCard.modal.captureEmpty');

    case StatusTypes.REJECTED:
      return t('MCTDetail.TrapHistoryCard.modal.reject');

    default:
      return '';
  }
};
